import React from 'react';

import { MediaLibrary as CommonsMediaLibrary } from 'commons/containers/MediaLibrary';
import { getCssForBackgroundImg } from 'craft/containers/Toolbox/sections/Background/utils';
import { useMultiNodes } from 'craft/hooks';

interface Props {
  nodeIds: string[];
  name: string;
  isModalOpen: boolean;
  toggleModal: () => void;
  setImageURL?: (url: string) => void;
}

export const MediaLibrary = ({ nodeIds, name, isModalOpen, toggleModal, setImageURL }: Props) => {
  const {
    props,
    actions: { setCss, setProps },
  } = useMultiNodes(nodeIds);

  // TODO: break this function up, it's doing WAAY too much
  const onSelectImage = (url: string) => {
    if (setImageURL) {
      setImageURL(url);
      return;
    }
    if (name === 'background') {
      setCss(getCssForBackgroundImg(url));
      return;
    }

    // if we already have a height and width (from a previously customised SRC), use that
    const previousWidth = props.width.value;
    const previousHeight = props.height.value;

    // When width and/or height is set by the user, keep the width when switching image
    // If only height has been set, keep the height
    const imageSize = {
      width: previousWidth || 'auto',
      height: !previousWidth ? previousHeight || 'auto' : 'auto',
    };

    setProps({
      ...imageSize,
      [name]: url,
    });
  };

  return (
    <CommonsMediaLibrary
      isModalOpen={isModalOpen}
      toggleModal={toggleModal}
      onSelectImage={onSelectImage}
    />
  );
};
